import { render, staticRenderFns } from "./NewsView.vue?vue&type=template&id=6140f74c&scoped=true"
import script from "./NewsView.vue?vue&type=script&lang=js"
export * from "./NewsView.vue?vue&type=script&lang=js"
import style0 from "./NewsView.vue?vue&type=style&index=0&id=6140f74c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6140f74c",
  null
  
)

export default component.exports